<template
    ><div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Background" | t }}:</v-col>
            <v-col class="col-item" cols="6">
                <v-menu v-model="menu.modal.background_color" top nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.background_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.background_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Header and footer background" | t }}:</v-col>
            <v-col class="col-item" cols="6">
                <v-menu v-model="menu.modal.header_and_footer_background_color" top nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.header_and_footer_background_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.header_and_footer_background_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Body background (text part)" | t }}:</v-col>
            <v-col class="col-item" cols="6">
                <v-menu v-model="menu.modal.body_background_color" top nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.body_background_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.body_background_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Border color" | t }}:</v-col>
            <v-col class="col-item" cols="6">
                <v-menu v-model="menu.modal.border_color" top nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.border_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.border_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Header text color" | t }}:</v-col>
            <v-col class="col-item" cols="6">
                <v-menu v-model="menu.modal.header_text_color" top nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.header_text_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.header_text_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Body text color" | t }}:</v-col>
            <v-col class="col-item" cols="6">
                <v-menu v-model="menu.modal.body_text_color" top nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.body_text_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.body_text_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Footer text color" | t }}:</v-col>
            <v-col class="col-item" cols="6">
                <v-menu v-model="menu.modal.footer_text_color" top nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.footer_text_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.footer_text_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Select text color" | t }}:</v-col>
            <v-col class="col-item" cols="6">
                <v-menu v-model="menu.modal.select_text_color" top nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.select_text_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.select_text_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Hovered bank border color" | t }}:</v-col>
            <v-col class="col-item" cols="6">
                <v-menu v-model="menu.modal.hovered_bank_border_color" top nudge-bottom="105"
                        nudge-left="16"
                        :close-on-content-click="false" :disabled="!editMode">
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle(activeCompany.ui_configurations.modal.hovered_bank_border_color)"
                             :class="{'cursor-not-allowed': !editMode}"
                             v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="activeCompany.ui_configurations.modal.hovered_bank_border_color" flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row v-if="editMode">
            <v-col cols="12">
                <v-btn color="black" class="mr-2" text @click="handleResetClick">
                    {{ "Reset" | t }}
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
    name: "ui-configurations-view-tab",
    data() {
        return {
            menu: {
                modal: {
                    header_and_footer_background_color: false,
                    body_background_color: false,
                    border_color: false,
                    text_color: false,
                    background_color: false,
                    header_text_color: false,
                    body_text_color: false,
                    footer_text_color: false,
                    select_text_color: false,
                    hovered_bank_border_color: false,
                }
            },
        }
    },
    computed: {
        ...mapState(["activeCompany"]),
        editMode () {
            return this.$route.name === 'company-edit';
        }
    },
    methods: {
        ...mapMutations(['resetActiveCompanyUiConfiguration']),
        handleResetClick() {
            this.resetActiveCompanyUiConfiguration()
        },
        swatchStyle(color) {
            return {
                backgroundColor: color,
                border: '1px solid #00000009',
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                borderRadius: '4px',
                transition: 'border-radius 200ms ease-in-out'
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
.cursor-not-allowed {
    cursor: not-allowed !important;
}
</style>
